document.documentElement.classList.add('js');

(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const intro = document.querySelector('[data-sfc-intro]');
  if (intro) {
    if (reduceMotion) intro.remove();
    else window.setTimeout(() => intro.classList.add('is-done'), 1150);
  }

  const revealItems = document.querySelectorAll('[data-reveal], .reveal-item, [data-fly]');
  if ('IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
    revealItems.forEach((el) => io.observe(el));
  } else {
    revealItems.forEach((el) => el.classList.add('is-visible'));
  }

  if (!reduceMotion) {
    const tenScene = document.querySelector('[data-ten-scene]');
    const ten = tenScene?.querySelector('.ten-depth');
    const hero = document.querySelector('[data-sfc-hero]');
    const heroMedia = hero?.querySelector('.hero-media');
    let ticking = false;
    const update = () => {
      const scrollY = window.scrollY || 0;
      if (hero && heroMedia) {
        const rect = hero.getBoundingClientRect();
        if (rect.bottom > 0) heroMedia.style.transform = `translate3d(0,${Math.min(scrollY * .12, 90)}px,0) scale(1.04)`;
      }
      if (tenScene && ten) {
        const r = tenScene.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, 1 - r.top / window.innerHeight));
        const scale = 0.72 + progress * 0.44;
        const y = 70 - progress * 70;
        ten.style.transform = `translate3d(0,${y}px,0) scale(${scale})`;
        ten.style.opacity = String(0.15 + progress * 0.82);
      }
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  if (!reduceMotion && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('[data-tilt]').forEach((card) => {
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - .5;
        const y = (e.clientY - r.top) / r.height - .5;
        card.style.transform = `perspective(900px) rotateY(${x * 7}deg) rotateX(${-y * 5}deg) translateY(-5px)`;
      });
      card.addEventListener('pointerleave', () => card.style.transform = '');
    });

    document.querySelectorAll('.magnetic').forEach((button) => {
      button.addEventListener('pointermove', (e) => {
        const r = button.getBoundingClientRect();
        button.style.transform = `translate(${(e.clientX-r.left-r.width/2)*.08}px, ${(e.clientY-r.top-r.height/2)*.08}px)`;
      });
      button.addEventListener('pointerleave', () => button.style.transform = '');
    });
  }
})();

(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = document.documentElement;

  if (!reduceMotion) {
    let pointerRAF = 0;
    window.addEventListener('pointermove', (e) => {
      if (pointerRAF) return;
      pointerRAF = requestAnimationFrame(() => {
        root.style.setProperty('--mx', `${e.clientX}px`);
        root.style.setProperty('--my', `${e.clientY}px`);
        document.querySelectorAll('[data-depth]').forEach((el) => {
          const depth = Number(el.dataset.depth || 10);
          const x = (e.clientX / Math.max(window.innerWidth,1) - .5) * depth;
          const y = (e.clientY / Math.max(window.innerHeight,1) - .5) * depth;
          el.style.transform = `translate3d(${x}px,${y}px,0)`;
        });
        pointerRAF = 0;
      });
    }, { passive:true });

    const updateProgress = () => {
      const max = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      root.style.setProperty('--scroll-p', String(Math.max(0, Math.min(1, window.scrollY / max))));
    };
    window.addEventListener('scroll', updateProgress, { passive:true });
    updateProgress();
  }

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduceMotion) {
    document.querySelectorAll('.interactive-card').forEach((card) => {
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        const x = ((e.clientX-r.left)/Math.max(r.width,1))*100;
        const y = ((e.clientY-r.top)/Math.max(r.height,1))*100;
        card.style.setProperty('--card-x', `${x}%`);
        card.style.setProperty('--card-y', `${y}%`);
      });
    });
  }

  document.querySelectorAll('.fact-chip').forEach((chip) => {
    chip.addEventListener('click', () => {
      const active = chip.classList.contains('is-active');
      document.querySelectorAll('.fact-chip').forEach((c) => c.classList.remove('is-active'));
      if (!active) chip.classList.add('is-active');
    });
  });
})();

// v6 — scene-based cinematic interaction
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scenes = [...document.querySelectorAll('[data-scene]')];
  const railLinks = [...document.querySelectorAll('[data-scene-link]')];

  if ('IntersectionObserver' in window) {
    const sceneObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        scenes.forEach((s) => s.classList.toggle('is-scene-live', s === entry.target));
        railLinks.forEach((a) => a.classList.toggle('is-active', a.dataset.sceneLink === entry.target.dataset.scene));
      });
    }, { threshold: 0.36, rootMargin: '-12% 0px -34% 0px' });
    scenes.forEach((scene) => sceneObserver.observe(scene));
  }

  const factCopy = {
    gross: ['GROSS MERCHANDISE SALES', 'The commitment is based on merchandise sales before business expenses are deducted — not net profit.'],
    transparent: ['TRANSPARENCY BY DESIGN', 'The site includes a dedicated transparency page so future donation updates can be published clearly without inventing impact history.'],
    mission: ['WHERE THE COMMITMENT POINTS', 'The 10% gross-merchandise-sales commitment supports Mission 22 through Still Fighting Co.’s official partnership.'],
    recipients: ['OFFICIAL NONPROFIT PARTNER', 'Mission 22 is the identified nonprofit recipient for this partnership. Still Fighting Co. remains independently owned and operated.']
  };
  const factPanel = document.querySelector('[data-fact-panel]');
  document.querySelectorAll('[data-fact]').forEach((button) => {
    button.addEventListener('click', () => {
      const copy = factCopy[button.dataset.fact];
      if (!copy || !factPanel) return;
      factPanel.classList.add('is-live');
      factPanel.innerHTML = `<span>${copy[0]}</span><p>${copy[1]}</p>`;
    });
  });

  if (!reduceMotion && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    document.querySelectorAll('[data-depth-card]').forEach((card) => {
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        const nx = (e.clientX-r.left)/Math.max(r.width,1)-.5;
        const ny = (e.clientY-r.top)/Math.max(r.height,1)-.5;
        card.style.transform = `perspective(850px) rotateY(${nx*5}deg) rotateX(${-ny*4}deg) translateY(-5px)`;
      });
      card.addEventListener('pointerleave', () => { card.style.transform = ''; });
    });
  }
})();


// Mission 22 partnership layered scroll parallax — transform-only, mobile-safe, reduced-motion aware.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const layers = [...document.querySelectorAll('[data-scroll-depth]')];
  if (reduceMotion || !layers.length) return;
  let raf = 0;
  const update = () => {
    const vh = Math.max(window.innerHeight, 1);
    layers.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.bottom < -120 || rect.top > vh + 120) return;
      const depth = Number(el.dataset.scrollDepth || 0.04);
      const centerDelta = (rect.top + rect.height * 0.5) - vh * 0.5;
      const y = Math.max(-70, Math.min(70, -centerDelta * depth));
      el.style.setProperty('--scroll-y', `${y.toFixed(2)}px`);
    });
    raf = 0;
  };
  const request = () => { if (!raf) raf = requestAnimationFrame(update); };
  window.addEventListener('scroll', request, { passive:true });
  window.addEventListener('resize', request, { passive:true });
  update();
})();

// v20 — immersive bridge, depth particles, and scroll-camera motion.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const bridge = document.querySelector('[data-bridge-scene]');
  if (!bridge) return;

  // Generate lightweight atmospheric particles locally — no external libraries, no WebGL dependency.
  const particleRoot = bridge.querySelector('[data-cinematic-particles]');
  if (particleRoot && !particleRoot.dataset.ready) {
    particleRoot.dataset.ready = 'true';
    const count = window.matchMedia('(max-width: 800px)').matches ? 18 : 34;
    const frag = document.createDocumentFragment();
    for (let i = 0; i < count; i += 1) {
      const dot = document.createElement('span');
      dot.className = 'bridge-particle';
      const x = (Math.random() * 100).toFixed(2) + '%';
      const y = (Math.random() * 100).toFixed(2) + '%';
      const z = (Math.random() * 180 - 90).toFixed(0) + 'px';
      dot.style.setProperty('--particle-x', x);
      dot.style.setProperty('--particle-y', y);
      dot.style.setProperty('--particle-z', z);
      dot.style.setProperty('--particle-s', (0.45 + Math.random() * 1.45).toFixed(2));
      dot.style.setProperty('--particle-o', (0.16 + Math.random() * 0.56).toFixed(2));
      dot.style.setProperty('--particle-d', (7 + Math.random() * 9).toFixed(1) + 's');
      dot.style.setProperty('--particle-delay', (-Math.random() * 8).toFixed(1) + 's');
      dot.style.setProperty('--particle-dx', (Math.random() * 38 - 19).toFixed(0) + 'px');
      dot.style.setProperty('--particle-dy', (-18 - Math.random() * 52).toFixed(0) + 'px');
      frag.appendChild(dot);
    }
    particleRoot.appendChild(frag);
  }

  if (reduceMotion) return;

  const planes = [...bridge.querySelectorAll('[data-bridge-depth]')];
  const product = bridge.querySelector('[data-bridge-product]');
  let raf = 0;
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const update = () => {
    const rect = bridge.getBoundingClientRect();
    const vh = Math.max(window.innerHeight, 1);
    const progress = clamp((vh - rect.top) / (vh + rect.height), 0, 1);
    const centered = progress - .5;

    planes.forEach((el) => {
      const depth = Number(el.dataset.bridgeDepth || .15);
      el.style.setProperty('--bridge-y', `${(centered * -220 * depth).toFixed(2)}px`);
    });

    const enter = clamp((progress - .08) / .34, 0, 1);
    const deepen = clamp((progress - .35) / .38, 0, 1);
    bridge.style.setProperty('--bridge-line-1-y', `${(58 - enter * 58).toFixed(1)}px`);
    bridge.style.setProperty('--bridge-line-1-z', `${(-90 + enter * 90).toFixed(1)}px`);
    bridge.style.setProperty('--bridge-line-1-s', `${(.91 + enter * .09).toFixed(3)}`);
    bridge.style.setProperty('--bridge-line-1-o', `${(.16 + enter * .84).toFixed(3)}`);
    bridge.style.setProperty('--bridge-line-1-b', `${(7 - enter * 7).toFixed(2)}px`);

    bridge.style.setProperty('--bridge-line-2-y', `${(96 - deepen * 96).toFixed(1)}px`);
    bridge.style.setProperty('--bridge-line-2-z', `${(-145 + deepen * 145).toFixed(1)}px`);
    bridge.style.setProperty('--bridge-line-2-s', `${(.86 + deepen * .14).toFixed(3)}`);
    bridge.style.setProperty('--bridge-line-2-o', `${(.10 + deepen * .90).toFixed(3)}`);
    bridge.style.setProperty('--bridge-line-2-b', `${(10 - deepen * 10).toFixed(2)}px`);
    bridge.style.setProperty('--bridge-rule-w', `${(clamp((progress - .45) / .22, 0, 1) * 100).toFixed(1)}%`);

    if (product) {
      const productFade = clamp(1 - Math.abs(progress - .46) * 2.1, 0, 1);
      bridge.style.setProperty('--bridge-product-scale', `${(.70 + progress * .36).toFixed(3)}`);
      bridge.style.setProperty('--bridge-product-ry', `${(-14 + progress * 24).toFixed(2)}deg`);
      bridge.style.setProperty('--bridge-product-opacity', `${(.08 + productFade * .30).toFixed(3)}`);
    }
    raf = 0;
  };
  const request = () => { if (!raf) raf = requestAnimationFrame(update); };
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request, { passive: true });
  update();
})();

// v21 — Still Fighting Companion: curated, safe routing. No diagnosis and no fake AI claims.
(() => {
  const root = document.querySelector('[data-sfc-companion]');
  if (!root) return;
  const response = root.querySelector('[data-companion-response]');
  const prompt = root.querySelector('[data-companion-prompt]');
  const options = root.querySelector('.companion-options');
  const label = root.querySelector('[data-companion-label]');
  const title = root.querySelector('[data-companion-title]');
  const body = root.querySelector('[data-companion-body]');
  const primary = root.querySelector('[data-companion-primary]');
  const reset = root.querySelector('[data-companion-reset]');
  const routes = {
    talk: ['CONNECTION', 'You do not have to carry the whole conversation perfectly.', 'Start with the resource hub and choose the kind of support that fits. If you are reaching out to someone you trust, a simple “I could use somebody with me right now” is enough to begin.', '/pages/get-support', 'FIND SUPPORT'],
    encouragement: ['ENCOURAGEMENT', 'Getting through today counts.', 'You do not have to solve the entire week, month, or future right now. Pick the next useful thing in front of you. Eat something. Step outside. Text somebody. Keep the next move small.', '#scene-06', 'SEE THE COMMUNITY'],
    help: ['SHOW UP', 'You do not need perfect words to show up for somebody.', 'Listen first. Stay present. Avoid trying to fix everything. If the situation feels urgent or unsafe, use the support resources and involve qualified help.', '/pages/get-support', 'OPEN SUPPORT GUIDE'],
    resources: ['RESOURCES', 'Get clear veteran support pathways without the sales pitch.', 'The support hub is intentionally separated from shopping. Use it to find crisis, mental health, VA, transition, family, housing, and other resource pathways.', '/pages/get-support', 'OPEN RESOURCE HUB'],
    mission: ['THE MISSION', 'The shirt carries the message. People give it meaning.', 'Still Fighting Co. uses apparel to fund and amplify a larger mission around connection, community, veteran mental health, and veteran suicide prevention.', '/pages/our-mission', 'DISCOVER THE MISSION'],
    gear: ['THE DROP', 'Find the gear that carries the message.', 'Head to the current collection for products, sizing, inventory, and the purchase-impact explanation tied to the giving commitment.', '/collections/all', 'SHOP THE DROP']
  };
  root.querySelectorAll('[data-companion-choice]').forEach((button) => {
    button.addEventListener('click', () => {
      const data = routes[button.dataset.companionChoice];
      if (!data) return;
      label.textContent = data[0]; title.textContent = data[1]; body.textContent = data[2]; primary.href = data[3]; primary.textContent = data[4];
      prompt.hidden = true; options.hidden = true; response.hidden = false; response.focus?.();
    });
  });
  reset?.addEventListener('click', () => { response.hidden = true; prompt.hidden = false; options.hidden = false; });
})();

// v21 — Wall support is intentionally device-local until a moderated backend exists.
(() => {
  const buttons = document.querySelectorAll('[data-wall-support]');
  buttons.forEach((button, index) => {
    const key = `sfc-wall-support-${index}-${location.pathname}`;
    const pressed = localStorage.getItem(key) === '1';
    button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    const label = button.querySelector('[data-wall-count-label]');
    if (pressed && label) label.textContent = 'YOU SHOWED UP';
    button.addEventListener('click', () => {
      const next = button.getAttribute('aria-pressed') !== 'true';
      button.setAttribute('aria-pressed', next ? 'true' : 'false');
      localStorage.setItem(key, next ? '1' : '0');
      if (label) label.textContent = next ? 'YOU SHOWED UP' : 'SHOW SUPPORT';
    });
  });
})();

// v21 — Dynamic purchase impact from selected Shopify variant price.
(() => {
  const root = document.querySelector('[data-product-page]');
  if (!root) return;
  const select = root.querySelector('[data-product-variant]');
  const impact = root.querySelector('[data-purchase-impact]');
  const output = root.querySelector('[data-impact-amount]');
  const price = root.querySelector('[data-product-price]');
  if (!select || !impact || !output) return;
  const percent = Number(impact.dataset.percent || 10);
  const currency = window.Shopify?.currency?.active || 'USD';
  const format = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency}).format(cents/100);
  const update = () => {
    const option = select.options[select.selectedIndex];
    const cents = Number(option?.dataset.price || 0);
    output.textContent = format(Math.round(cents * percent / 100));
    if (price) price.textContent = format(cents);
  };
  select.addEventListener('change', update); update();
})();

// v21 — Private, client-side 9:16 share card generator.
(() => {
  const root = document.querySelector('[data-share-studio]');
  if (!root) return;
  const canvas = root.querySelector('[data-share-canvas]');
  const create = root.querySelector('[data-share-create]');
  const share = root.querySelector('[data-share-share]');
  const frame = root.querySelector('.share-preview__frame');
  const note = root.querySelector('[data-share-note]');
  if (!canvas || !create) return;
  let statement = "I'M STILL FIGHTING FOR MY FAMILY.";
  let blob = null;
  root.querySelectorAll('[data-share-statement]').forEach((button) => {
    button.addEventListener('click', () => {
      root.querySelectorAll('[data-share-statement]').forEach((b) => b.classList.remove('is-active'));
      button.classList.add('is-active'); statement = button.dataset.shareStatement;
    });
  });
  const wrap = (ctx, text, maxWidth, fontSize) => {
    const words = text.split(' '), lines=[]; let line='';
    ctx.font = `900 ${fontSize}px Arial, Helvetica, sans-serif`;
    words.forEach((word) => { const test=(line+' '+word).trim(); if (ctx.measureText(test).width > maxWidth && line) { lines.push(line); line=word; } else line=test; });
    if (line) lines.push(line); return lines;
  };
  const draw = () => {
    const ctx = canvas.getContext('2d'); const w=canvas.width,h=canvas.height;
    const g=ctx.createLinearGradient(0,0,w,h); g.addColorStop(0,'#11100f'); g.addColorStop(.62,'#070707'); g.addColorStop(1,'#160b09'); ctx.fillStyle=g; ctx.fillRect(0,0,w,h);
    ctx.strokeStyle='rgba(221,209,188,.15)'; ctx.lineWidth=2; ctx.strokeRect(54,54,w-108,h-108);
    ctx.fillStyle='#8f2924'; ctx.fillRect(72,98,130,8);
    ctx.fillStyle='#90887d'; ctx.font='700 28px Arial'; ctx.letterSpacing='4px'; ctx.fillText('STILL FIGHTING CO.',72,170);
    ctx.fillStyle='#e1d8c9'; const lines=wrap(ctx,statement,900,92); let y=690; lines.forEach((line,i)=>{ctx.fillText(line,72,y+i*102)});
    ctx.fillStyle='#ae332c'; ctx.fillRect(72,1120,220,10);
    ctx.fillStyle='#a49c90'; ctx.font='700 30px Arial'; ctx.fillText('NO VETERAN SHOULD FIGHT ALONE.',72,1210);
    ctx.fillStyle='#6f6961'; ctx.font='700 24px Arial'; ctx.fillText('THE SHIRT ISN\'T THE MISSION. IT\'S HOW WE FUND IT.',72,1700);
    ctx.fillStyle='#c5bbac'; ctx.font='700 22px Arial'; ctx.fillText('STILLFIGHTINGCO.COM',72,1780);
    frame?.classList.add('is-ready');
    canvas.toBlob((b)=>{ blob=b; share.hidden = !(navigator.share && b); },'image/png');
  };
  create.addEventListener('click', draw);
  share?.addEventListener('click', async () => {
    if (!blob || !navigator.share) return;
    try { const file=new File([blob],'still-fighting-card.png',{type:'image/png'}); await navigator.share({files:[file],title:'Still Fighting Co.'}); }
    catch (e) { if (e?.name !== 'AbortError' && note) note.textContent='Your device did not complete sharing. You can still use the card preview.'; }
  });
})();

// v21 — Real launch countdown. Uses the configured actual date; never fabricates scarcity.
(() => {
  const root = document.querySelector('[data-drop-countdown]');
  if (!root) return;
  const target = new Date(root.dataset.launch || '');
  const output = root.querySelector('[data-drop-time]');
  const state = root.querySelector('[data-drop-state]');
  if (!target.getTime() || !output) return;
  const tick = () => {
    const diff = target.getTime() - Date.now();
    if (diff <= 0) { output.textContent='THE FOUNDERS DROP IS LIVE'; if(state) state.textContent='CHECK CURRENT SHOPIFY INVENTORY'; return; }
    const d=Math.floor(diff/86400000), h=Math.floor(diff/3600000)%24, m=Math.floor(diff/60000)%60, s=Math.floor(diff/1000)%60;
    output.textContent=`${d}D ${String(h).padStart(2,'0')}H ${String(m).padStart(2,'0')}M ${String(s).padStart(2,'0')}S`;
    if(state) state.textContent='UNTIL THE FOUNDERS DROP';
  };
  tick(); setInterval(tick,1000);
})();

// v23 — futuristic home interactions, deliberately lightweight.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Accessible mobile menu.
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
    menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', 'false'); menu.hidden = true; document.body.classList.remove('menu-open');
    }));
  }

  // Product image switcher uses actual Shopify product media already rendered by Liquid.
  const images = [...document.querySelectorAll('[data-product-image]')];
  const dots = [...document.querySelectorAll('[data-product-dot]')];
  const showImage = (index) => {
    images.forEach((el) => el.classList.toggle('is-active', el.dataset.imageIndex === String(index)));
    dots.forEach((el) => el.classList.toggle('is-active', el.dataset.imageIndex === String(index)));
  };
  dots.forEach((dot) => dot.addEventListener('click', () => showImage(dot.dataset.imageIndex)));

  // A tiny cursor-reactive camera shift on desktop only; transform-only for performance.
  const hero = document.querySelector('[data-future-hero]');
  if (hero && !reduceMotion && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
    let raf = 0;
    hero.addEventListener('pointermove', (e) => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        const x = (e.clientX / Math.max(innerWidth, 1) - .5);
        const y = (e.clientY / Math.max(innerHeight, 1) - .5);
        hero.style.setProperty('--future-x', `${x * 10}px`);
        hero.style.setProperty('--future-y', `${y * 7}px`);
        const media = hero.querySelector('.future-hero__media');
        if (media) media.style.transform = `translate3d(${x * -7}px,${y * -5}px,0)`;
        raf = 0;
      });
    }, { passive:true });
  }
})();

// v29 — Six Branches: six distinct cinematic branch tributes.
(() => {
  const root = document.querySelector('[data-branch-tribute]');
  if (!root) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const panel = root.querySelector('[data-branch-panel]');
  const aircraft = root.querySelector('[data-branch-aircraft]');
  const airspace = root.querySelector('.future-branches__airspace');
  const flightPath = root.querySelector('[data-branch-flight-path]');
  const emblemBox = root.querySelector('[data-branch-emblem]');
  const officialSlot = root.querySelector('[data-branch-official-slot]');
  const els = {
    code: root.querySelector('[data-branch-code]'), label: root.querySelector('[data-branch-label]'),
    mottoPrefix: root.querySelector('[data-branch-motto-prefix]'), motto: root.querySelector('[data-branch-motto]'), slotName: root.querySelector('[data-branch-slot-name]'),
    machine: root.querySelector('[data-branch-machine]'), title: root.querySelector('[data-branch-title]'),
    copy: root.querySelector('[data-branch-copy]'), backdrop: root.querySelector('[data-branch-backdrop]'),
    domain: root.querySelector('[data-branch-domain]'), culture: root.querySelector('[data-branch-culture]'),
    flightLabel: root.querySelector('[data-branch-flight-label]')
  };
  const branches = {
    army:{code:'BRANCH / 01',label:'UNITED STATES ARMY',mottoPrefix:'MOTTO /',motto:"THIS WE’LL DEFEND",machine:'ROTARY-WING / GROUND FORCE',title:'FOR THE SOLDIERS WHO CARRIED THE MISSION FORWARD.',copy:'For the Soldiers who carried the mission across generations—on the ground, in the air, and wherever duty demanded. From infantry and armor to aviation, logistics, intelligence, medical, communications, administration, and every specialty that kept the formation moving—your service is seen here.',backdrop:'GROUND / AIR / GLOBAL RESPONSE',domain:'LAND POWER',culture:'SOLDIERS / TEAMS / MISSION',accent:'#c5a253',flightLabel:'ARMY / ROTARY-WING TRIBUTE',path:'M10 54h54l20-10h18l8-9h42l8 9h31l17 8h28v5h-28l-17 8h-31l-8 9h-42l-8-9H84L64 56H10Zm84-27h45v4H94Zm18-8h28v4h-28Z'},
    marines:{code:'BRANCH / 02',label:'UNITED STATES MARINE CORPS',mottoPrefix:'MOTTO /',motto:'SEMPER FIDELIS',machine:'TILTROTOR / EXPEDITIONARY FORCE',title:'FOR THE MARINES WHO CARRIED THE TITLE WITH THEM.',copy:'For the Marines shaped by discipline, expeditionary service, tradition, and a title that does not simply disappear when the uniform comes off. From infantry and aviation to logistics, intelligence, communications, maintenance, administration, and support—the bond and identity built in the Corps are recognized here.',backdrop:'AIR / LAND / SEA / EXPEDITIONARY',domain:'EXPEDITIONARY FORCE',culture:'MARINES / TRADITION / CORPS',accent:'#c51f2a',flightLabel:'MARINE CORPS / TILTROTOR TRIBUTE',path:'M14 53h48l24-10h22l13-18h18l8 18h34l19-10h21l-12 18 36 2-36 3 12 18h-21l-19-10h-34l-8 18h-18l-13-18H86L62 56H14Z'},
    navy:{code:'BRANCH / 03',label:'UNITED STATES NAVY',mottoPrefix:'CORE VALUES /',motto:'HONOR, COURAGE, COMMITMENT',machine:'CARRIER AVIATION / FLEET',title:'FOR THE SAILORS WHO SERVED BEYOND THE HORIZON.',copy:'For the Sailors who knew watches, deployments, ships, submarines, flight decks, shore commands, and long stretches far from home. From engineering and aviation to medical, intelligence, logistics, security, administration, and the countless ratings that keep the fleet moving—your story belongs here.',backdrop:'SEA / SUBSURFACE / AVIATION',domain:'SEA POWER',culture:'SAILORS / FLEET / WATCH',accent:'#c6a75e',flightLabel:'NAVY / CARRIER AVIATION TRIBUTE',path:'M7 52 76 47l34-20h17l-10 19 39-2 26-13h14l-7 14 54 4 10 4-10 4-54 4 7 14h-14l-26-13-39-2 10 19h-17L76 59 7 54Z'},
    airforce:{code:'BRANCH / 04',label:'UNITED STATES AIR FORCE',mottoPrefix:'MOTTO /',motto:'AIM HIGH … FLY-FIGHT-WIN',machine:'FIGHTER / GLOBAL AIRPOWER',title:'FOR THE AIRMEN WHO KEPT THE MISSION MOVING.',copy:'For the Airmen behind airpower—pilots and aircrew, maintainers, security forces, logistics, intelligence, communications, medical, civil engineering, administration, operations, and every career field that makes global reach possible. The mission was never one job; it was the people beside you.',backdrop:'AIR / GLOBAL REACH / READINESS',domain:'AIRPOWER',culture:'AIRMEN / WINGS / MISSION',accent:'#7ca6d8',flightLabel:'AIR FORCE / FIGHTER TRIBUTE',path:'M7 52 86 45l32-28h14l-9 27 43-3 25-16h13l-9 17 48 7 10 4-10 4-48 7 9 17h-13l-25-16-43-3 9 27h-14L86 61 7 54Z'},
    spaceforce:{code:'BRANCH / 05',label:'UNITED STATES SPACE FORCE',mottoPrefix:'MOTTO /',motto:'SEMPER SUPRA — ALWAYS ABOVE',machine:'SATELLITE / ORBITAL SYSTEM',title:'FOR THE GUARDIANS SERVING IN A NEW DOMAIN.',copy:'For the Guardians protecting and enabling the systems the nation depends on—space operations, missile warning, cyber, intelligence, satellite command and control, acquisition, engineering, and support. The service may be young, but the responsibility, vigilance, and weight of the mission are real.',backdrop:'ORBIT / CYBER / SPACE DOMAIN',domain:'SPACEPOWER',culture:'GUARDIANS / ORBIT / VIGILANCE',accent:'#b9c4d2',flightLabel:'SPACE FORCE / ORBITAL SYSTEM TRIBUTE',path:'M130 16c21 0 38 17 38 38s-17 38-38 38-38-17-38-38 17-38 38-38Zm0 13c-14 0-25 11-25 25s11 25 25 25 25-11 25-25-11-25-25-25Zm-70 23h25v5H60Zm115 0h25v5h-25ZM90 15l13 22-5 3-13-22Zm72 0 5 3-13 22-5-3ZM90 93l-5-3 13-22 5 3Zm72 0-13-22 5-3 13 22Z'},
    coastguard:{code:'BRANCH / 06',label:'UNITED STATES COAST GUARD',mottoPrefix:'MOTTO /',motto:'SEMPER PARATUS — ALWAYS READY',machine:'RESCUE AVIATION / CUTTER FORCE',title:'FOR THE COAST GUARDSMEN WHO ANSWERED WHEN HELP WAS NEEDED MOST.',copy:'For the Coast Guardsmen who served through rescues, maritime security, law enforcement, disasters, ports, cutters, aviation, engineering, intelligence, logistics, administration, and dangerous water. Your service often met people on their worst day—and the courage and crew bond behind that mission are seen here.',backdrop:'RESCUE / SECURITY / WATERWAYS',domain:'MARITIME RESPONSE',culture:'COAST GUARDSMEN / RESCUE / CREW',accent:'#e35b2f',flightLabel:'COAST GUARD / RESCUE AVIATION TRIBUTE',path:'M12 53h50l20-9h24l11-13h34l11 13h26l16-7h26v5h24v10h-24v5h-26l-16-7h-26l-11 13h-34l-11-13H82l-20-9H12Zm111-29h23v4h-23Z'}
  };
  const refly=()=>{if(!aircraft||reduceMotion)return;aircraft.classList.remove('is-flying');void aircraft.offsetWidth;aircraft.classList.add('is-flying')};
  const swapAssets=(key)=>{
    let hasEmblem=false;
    root.querySelectorAll('[data-branch-emblem-img]').forEach(img=>{const active=img.dataset.branchEmblemImg===key;img.classList.toggle('is-active',active);if(active)hasEmblem=true});
    if(officialSlot) officialSlot.hidden=hasEmblem;
    root.querySelectorAll('[data-branch-flag]').forEach(img=>img.classList.toggle('is-active',img.dataset.branchFlag===key));
  };
  const setBranch=(key,button)=>{
    const branch=branches[key];if(!branch)return;
    root.querySelectorAll('[data-branch-tab]').forEach(b=>{const active=b===button;b.classList.toggle('is-active',active);b.setAttribute('aria-selected',active?'true':'false');b.setAttribute('tabindex',active?'0':'-1')});
    if(panel){panel.className=`future-branches__tribute branch-theme--${key}`;panel.dataset.activeBranch=key;panel.classList.add('is-switching');setTimeout(()=>panel.classList.remove('is-switching'),520)}
    if(airspace)airspace.style.setProperty('--flight-accent',branch.accent);if(flightPath)flightPath.setAttribute('d',branch.path);
    Object.keys(els).forEach(name=>{if(els[name]&&branch[name]!=null)els[name].textContent=branch[name]});
    if(els.slotName)els.slotName.textContent=branch.label;
    if(emblemBox)emblemBox.setAttribute('aria-label',`${branch.label} official emblem area`);
    swapAssets(key);refly();
  };
  const tabs=[...root.querySelectorAll('[data-branch-tab]')];
  tabs.forEach((button,index)=>{button.setAttribute('tabindex',index===0?'0':'-1');button.addEventListener('click',()=>setBranch(button.dataset.branchTab,button));button.addEventListener('keydown',event=>{if(!['ArrowDown','ArrowUp','ArrowRight','ArrowLeft','Home','End'].includes(event.key))return;event.preventDefault();let next=index;if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else if(event.key==='ArrowDown'||event.key==='ArrowRight')next=(index+1)%tabs.length;else next=(index-1+tabs.length)%tabs.length;tabs[next].focus();setBranch(tabs[next].dataset.branchTab,tabs[next])})});
  if(tabs[0])setBranch('army',tabs[0]);
})();

